<app-content-box>
  <h5>{{ labels.TITLE }}</h5>
  <form [formGroup]="examForm" (ngSubmit)="sendExam()">
    <div class="form-group">
      <app-autocomplete-dropdown
        [label]="labels.PATIENT_SELECTION_LABEL"
        [options]="allPatients"
        [displayWith]="displayPatientFn"
        [selectedValue]="selectedPatient"
        (selectionChange)="onPatientSelectionChange($event)"
      >
        <ng-template>
          <button
            type="button"
            (click)="openCreatePatientDialog()"
            class="btn btn-primary create-btn"
          >
            {{ labels.CREATE_PATIENT }}
          </button>
        </ng-template>
      </app-autocomplete-dropdown>
    </div>
    <div class="form-group">
      <app-autocomplete-dropdown
        [label]="labels.DOCTOR_SELECTION_LABEL"
        [options]="allDoctors"
        [displayWith]="displayDoctorFn"
        [selectedValue]="selectedAssignedTo"
        (selectionChange)="onDoctorSelectionChange($event)"
      ></app-autocomplete-dropdown>
    </div>
    <div class="form-group">
      <app-autocomplete-dropdown
        [label]="labels.TISSUE_REGION_SELECTION_LABEL"
        [options]="allTissueRegions"
        [displayWith]="displayTissueRegionFn"
        [selectedValue]="selectedTissue"
        (selectionChange)="onTissueRegionSelectionChange($event)"
      ></app-autocomplete-dropdown>
    </div>
    <div class="form-group">
      <label class="control-label" for="description">
        {{ labels.EXAM_DESCRIPTION }}
      </label>
      <textarea formControlName="description" class="form-control"></textarea>
    </div>
    <div class="form-group">
      <label class="control-label" for="urgency">
        {{ labels.EXAM_URGENCY }}
      </label>
      <select class="form-control" formControlName="urgency">
        <option [ngValue]="labels.URGENCY_YES">
          {{ labels.URGENCY_YES }}
        </option>
        <option [ngValue]="labels.URGENCY_NO">
          {{ labels.URGENCY_NO }}
        </option>
      </select>
    </div>
    <div class="form-group">
      <label class="control-label" for="images">
        {{ labels.IMAGES }}
      </label>
      <app-register-image
      [currentImagesData]="imageData"
        (newImageIds)="handleImagesChanged($event)"
      ></app-register-image>
    </div>
    <button type="submit" class="btn btn-primary submit-btn">
      {{ labels.SUBMIT_EXAM }}
    </button>
  </form>
</app-content-box>
